export var Status;
(function (Status) {
    Status["Idle"] = "";
    Status["Pending"] = "pending";
    Status["Fulfilled"] = "fulfilled";
    Status["Error"] = "error";
})(Status || (Status = {}));
